import { CoordinatesAlias } from "constant";

export const getCoordinatesSystem = (): CoordinatesAlias =>
  JSON.parse(localStorage.getItem("coordinatesSystem")) || "dd";

export const saveCoordinatesSystem = (data: CoordinatesAlias | {}): void =>
  localStorage.setItem("coordinatesSystem", JSON.stringify(data));
